//
//
//
//
//
//
//
//

import { getUserInfo, isWeiXin, system } from '@/util/const'
import { getQueryVariable } from '@/util/const'

export default {
  components: {

  },
  data () {
    return {
      bosstoken: '',
      thirdtoken: ''
    }
  },
  created () {
    this.bosstoken = getQueryVariable('bosstoken')
    this.thirdtoken = getQueryVariable('thirdtoken')
  },
  mounted () {

  },
  methods: {}
}



// WEBPACK FOOTER //
// ./src/page/greenchannel/param.vue